export const internationalExchangePrograms = [
  {
    id: 1,
    title: '한국으로 찾아가는 국제교류',
    subtitle: 'Short-term Study Abroad Experience in Korea',
    description: '일본 → 한국',
    target: '일본 청소년 및 성인',
    duration: '단기형, 장기형 (운영 방식 협의 가능)',
    features: ['관광', '직업 체험', '자격증 취득 (선택형 프로그램)', '항공, 비자, 숙박 협조 가능 (별도 안내)'],
    image: 'https://public.readdy.ai/ai/img_res/aab5d0e577af8dedb409db724bd52db0.jpg'
  },
  {
    id: 2,
    title: '일본으로 찾아가는 국제교류',
    subtitle: 'Career Experience in Japan',
    description: '한국 → 일본',
    target: '한국 청소년 및 성인',
    duration: '단기형, 장기형 (운영 방식 협의 가능)',
    features: ['관광', '학교 방문', '직업 체험', '항공, 비자, 숙박 협조 가능 (별도 안내)'],
    image: 'https://readdy.ai/api/search-image?query=korean%20high%20school%20students%20visiting%20modern%20japanese%20robotics%20and%20AI%20technology%20companies%2C%20observing%20advanced%20robots%20and%20artificial%20intelligence%20demonstrations%2C%20clean%20futuristic%20laboratory%20environment%20with%20white%20walls%2C%20students%20wearing%20school%20uniforms%20taking%20notes%2C%20professional%20educational%20setting%2C%20bright%20indoor%20lighting%2C%20career%20exploration%20atmosphere&width=800&height=1000&seq=japan-exchange-002&orientation=portrait'
  },
  {
    id: 3,
    title: '문화 체험 활동',
    subtitle: 'Cultural Experience Program',
    description: '한국·일본 전통문화 체험',
    target: '초·중·고등학생',
    duration: '1일 ~ 1주',
    features: ['전통 공예 체험', '현지 음식 문화', '역사 유적지 탐방', '현지 학생과의 교류'],
    image: 'https://readdy.ai/api/search-image?query=diverse%20group%20of%20students%20experiencing%20traditional%20korean%20and%20japanese%20cultural%20activities%20including%20tea%20ceremony%20and%20traditional%20crafts%2C%20wearing%20traditional%20hanbok%20and%20kimono%2C%20peaceful%20temple%20or%20cultural%20center%20setting%20with%20wooden%20architecture%2C%20warm%20natural%20lighting%2C%20cultural%20immersion%20and%20hands-on%20learning%2C%20respectful%20and%20educational%20atmosphere&width=800&height=1000&seq=culture-exchange-003&orientation=portrait'
  },
  {
    id: 4,
    title: '산업 탐방 활동',
    subtitle: 'Industry Field Trip Program',
    description: '첨단 산업 현장 방문',
    target: '중·고등학생 및 대학생',
    duration: '반일 ~ 3일',
    features: ['IT·반도체 기업 견학', '제조업 현장 체험', '스타트업 방문', '산업 전문가 멘토링'],
    image: 'https://readdy.ai/api/search-image?query=students%20touring%20modern%20high-tech%20manufacturing%20facility%20and%20semiconductor%20factory%2C%20observing%20advanced%20industrial%20equipment%20and%20production%20lines%2C%20clean%20room%20environment%20with%20blue%20lighting%2C%20students%20wearing%20safety%20gear%20and%20helmets%2C%20professional%20industrial%20setting%2C%20educational%20field%20trip%20atmosphere%2C%20innovation%20and%20technology%20focus&width=800&height=1000&seq=industry-visit-004&orientation=portrait'
  }
];

export const mainPrograms = [
  {
    id: 1,
    title: '원데이클래스 (현장방문형)',
    description: '체험 장소에 참가자가 직접 방문하여 현장 라운딩과 전문 직업인 멘토의 지도를 통해 심층적인 직업체험을 진행합니다. 이를 통해 학생들이 다양한 직업 세계를 이해하고 올바른 진로 방향을 설정할 수 있도록 돕습니다.',
    icon: 'ri-map-pin-user-line',
    image: 'https://readdy.ai/api/search-image?query=korean%20high%20school%20students%20visiting%20professional%20workplace%20for%20hands-on%20career%20experience%20with%20mentor%20guidance%2C%20bright%20modern%20office%20environment%20with%20natural%20lighting%2C%20students%20actively%20engaging%20in%20practical%20work%20activities%2C%20professional%20documentary%20photography%20style%2C%20inspiring%20career%20exploration%20atmosphere&width=600&height=600&seq=main-program-oneday-001&orientation=squarish'
  },
  {
    id: 2,
    title: '진로콘서트 (학교&기업 방문형 직업체험)',
    description: '전문 직업인 강사가 학교 또는 기업 현장으로 직접 방문하여 학급별로 다양한 직업을 체험할 수 있도록 지원합니다. 이를 통해 학생들이 다양한 직업 세계를 경험하며 자신의 진로를 탐색할 수 있도록 돕습니다.',
    icon: 'ri-user-voice-line',
    image: 'https://readdy.ai/api/search-image?query=professional%20career%20expert%20conducting%20interactive%20workshop%20in%20school%20classroom%20with%20korean%20students%2C%20hands-on%20career%20activities%20and%20demonstrations%2C%20bright%20educational%20environment%20with%20engaged%20students%2C%20professional%20documentary%20photography%20style%2C%20dynamic%20learning%20atmosphere&width=600&height=600&seq=main-program-concert-002&orientation=squarish'
  },
  {
    id: 3,
    title: '국제교류 프로그램',
    description: '한국-일본 간 문화·산업·진로 체험을 통한 글로벌 역량 강화',
    icon: 'ri-global-line',
    image: 'https://readdy.ai/api/search-image?query=diverse%20international%20students%20from%20korea%20and%20japan%20collaborating%20together%20in%20modern%20bright%20classroom%2C%20engaging%20in%20cultural%20exchange%20activities%20with%20world%20map%20and%20flags%20in%20background%2C%20warm%20natural%20lighting%20through%20large%20windows%2C%20friendly%20and%20inclusive%20atmosphere%2C%20students%20smiling%20and%20interacting%2C%20educational%20partnership%20and%20global%20citizenship%20theme&width=600&height=600&seq=main-program-001&orientation=squarish'
  },
  {
    id: 4,
    title: '진로 특강',
    description: '미래 산업 사회 변화 이해 및 자기 성찰 기반 진로 설정',
    icon: 'ri-presentation-line',
    image: 'https://readdy.ai/api/search-image?query=professional%20career%20counselor%20giving%20inspiring%20presentation%20to%20attentive%20high%20school%20students%20in%20modern%20auditorium%2C%20large%20screen%20displaying%20future%20career%20paths%20and%20industry%20trends%2C%20students%20taking%20notes%20and%20raising%20hands%2C%20motivational%20and%20educational%20atmosphere%2C%20warm%20stage%20lighting%2C%20personal%20growth%20and%20career%20development%20theme&width=600&height=600&seq=main-program-003&orientation=squarish'
  },
  {
    id: 5,
    title: '대학 탐방',
    description: '국내·해외 대학 캠퍼스 방문 및 진로 연계형 탐방',
    icon: 'ri-school-line',
    image: 'https://readdy.ai/api/search-image?query=high%20school%20students%20walking%20through%20beautiful%20university%20campus%20with%20historic%20academic%20buildings%20and%20modern%20facilities%2C%20autumn%20season%20with%20colorful%20trees%2C%20students%20carrying%20notebooks%20and%20looking%20inspired%2C%20prestigious%20university%20atmosphere%20with%20stone%20pathways%2C%20bright%20sunny%20day%2C%20educational%20aspiration%20and%20future%20planning%20theme&width=600&height=600&seq=main-program-002&orientation=squarish'
  },
  {
    id: 6,
    title: '창업 & 자격증 취득과정',
    description: '창업과 실무 역량을 동시에 키울 수 있도록 구성된 프로그램으로, 다양한 분야의 전문가와 함께 창업 아이디어 기획부터 실전 프로젝트까지 경험할 수 있습니다. 또한 분야별 자격증 취득 과정과 연계하여 학생들이 미래 사회에 필요한 실질적인 역량을 갖추고 자신의 진로와 직업 가능성을 확장할 수 있도록 지원합니다.',
    icon: 'ri-lightbulb-flash-line',
    image: 'https://readdy.ai/api/search-image?query=young%20entrepreneurs%20and%20students%20working%20on%20startup%20business%20ideas%20in%20modern%20bright%20coworking%20space%2C%20brainstorming%20with%20laptops%20and%20whiteboards%2C%20professional%20mentors%20guiding%20project%20development%2C%20innovative%20and%20creative%20atmosphere%20with%20natural%20lighting%2C%20professional%20documentary%20photography%20style%2C%20entrepreneurship%20and%20skill%20development%20theme&width=600&height=600&seq=main-program-startup-006&orientation=squarish'
  }
];

export const testimonials = [
  {
    id: 1,
    name: '김지우',
    school: '서울 ○○고등학교 2학년',
    content: 'Branch의 일본 진로 체험 프로그램을 통해 로봇 공학에 대한 꿈을 구체화할 수 있었습니다. 현장에서 직접 보고 느낀 경험이 진로 선택에 큰 도움이 되었어요.',
    program: '일본 진로 체험',
    image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20confident%20korean%20female%20high%20school%20student%20in%20school%20uniform%2C%20warm%20smile%2C%20standing%20in%20modern%20school%20hallway%20with%20natural%20window%20light%2C%20clean%20and%20bright%20atmosphere%2C%20educational%20success%20and%20achievement%20theme%2C%20realistic%20photography%20style&width=400&height=600&seq=testimonial-001&orientation=portrait'
  },
  {
    id: 2,
    name: '박서준',
    school: '경기 △△고등학교 3학년',
    content: '대학 탐방 프로그램에서 만난 선배들의 이야기가 정말 인상 깊었습니다. 막연했던 대학 생활이 구체적으로 그려지면서 목표가 명확해졌어요.',
    program: '대학 탐방',
    image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20enthusiastic%20korean%20male%20high%20school%20student%20in%20casual%20modern%20clothing%2C%20confident%20expression%2C%20university%20campus%20background%20with%20blurred%20buildings%2C%20natural%20daylight%2C%20educational%20aspiration%20and%20determination%20theme%2C%20realistic%20photography%20style&width=400&height=600&seq=testimonial-002&orientation=portrait'
  },
  {
    id: 3,
    name: '이서연',
    school: '인천 □□고등학교 1학년',
    content: '한국 문화를 일본 친구들에게 소개하면서 우리 문화의 가치를 다시 발견했습니다. 국제교류를 통해 글로벌 시민으로 성장하는 계기가 되었어요.',
    program: '국제교류 체험',
    image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20cheerful%20korean%20female%20high%20school%20student%20in%20casual%20modern%20outfit%2C%20bright%20smile%2C%20standing%20in%20cultural%20exchange%20center%20with%20international%20flags%20in%20background%2C%20warm%20and%20welcoming%20lighting%2C%20global%20citizenship%20and%20cultural%20pride%20theme%2C%20realistic%20photography%20style&width=400&height=600&seq=testimonial-003&orientation=portrait'
  }
];

export const faqs = [
  {
    id: 1,
    question: '프로그램 참가 신청은 어떻게 하나요?',
    answer: '홈페이지의 "프로그램 신청하기" 메뉴를 통해 온라인으로 신청하실 수 있습니다. 신청서 작성 후 담당자가 연락드려 상세한 안내를 제공해드립니다.'
  },
  {
    id: 2,
    question: '프로그램 참가 비용은 얼마인가요?',
    answer: '프로그램 종류, 기간, 참가 인원에 따라 비용이 상이합니다. 신청서 제출 후 맞춤 견적을 안내해드리며, 단체 신청 시 할인 혜택이 적용됩니다.'
  },
  {
    id: 3,
    question: '국제교류 프로그램은 언제 진행되나요?',
    answer: '국제교류 프로그램은 방학 기간(여름/겨울)을 중심으로 진행되며, 학교 단체의 경우 학기 중에도 일정 조율이 가능합니다. 최소 2개월 전 사전 신청을 권장합니다.'
  },
  {
    id: 4,
    question: '개인도 참가할 수 있나요?',
    answer: '네, 개인 참가도 가능합니다. 소규모 그룹으로 진행되는 프로그램에 참여하실 수 있으며, 비슷한 연령대의 참가자들과 함께 활동하게 됩니다.'
  },
  {
    id: 5,
    question: '안전 관리는 어떻게 이루어지나요?',
    answer: '모든 프로그램은 인솔 교사 및 현지 가이드가 동행하며, 24시간 비상 연락 체계를 운영합니다. 또한 단체 여행자 보험에 가입하여 안전을 최우선으로 관리합니다.'
  },
  {
    id: 6,
    question: '언어가 서툴러도 참가할 수 있나요?',
    answer: '네, 가능합니다. 통역 지원이 제공되며, 언어 능력보다는 적극적인 참여 의지와 문화 교류에 대한 열린 마음이 더 중요합니다.'
  }
];

export const notices = [
  {
    id: 1,
    title: '2025년 여름방학 일본 진로 체험 프로그램 모집 안내',
    date: '2025-01-15',
    category: '모집공고',
    isNew: true
  },
  {
    id: 2,
    title: '대학 탐방 프로그램 일정 변경 안내',
    date: '2025-01-10',
    category: '공지사항',
    isNew: true
  },
  {
    id: 3,
    title: '2024년 하반기 국제교류 프로그램 성과 보고',
    date: '2024-12-28',
    category: '활동보고',
    isNew: false
  },
  {
    id: 4,
    title: '설 연휴 고객센터 운영 안내',
    date: '2024-12-20',
    category: '공지사항',
    isNew: false
  },
  {
    id: 5,
    title: '2025년 상반기 진로 특강 프로그램 오픈',
    date: '2024-12-15',
    category: '모집공고',
    isNew: false
  }
];
